import type { Maybe } from '@adornis/base/utilTypes.js';
import { todayAsCalendarDay } from '@adornis/datetime/calendarDay.js';
import { Lohnart } from '../../contracts/enums/Lohnart.js';
import type { LodasPersonData } from '../../server/lodas/LodasPersonData.js';

// TODO add LEISTZULAGE back. We currently do not know the corresponding number in lodas
const allowedTypes = [Lohnart.INFLATIONPRAEMIE, Lohnart.JAHRESSONDERZAHLUNG, Lohnart.MEHR_ARBEIT, Lohnart.LEISTZULAGE];

const customLodasMapForSpecificThings = {};
customLodasMapForSpecificThings[Lohnart.INFLATIONPRAEMIE] = 28;
customLodasMapForSpecificThings[Lohnart.JAHRESSONDERZAHLUNG] = 241;
customLodasMapForSpecificThings[Lohnart.MEHR_ARBEIT] = 1804;
customLodasMapForSpecificThings[Lohnart.LEISTZULAGE] = 720;

function getDate(z: { month: number; year: Maybe<number> }) {
  return `01.${String(z.month + 1).padStart(2, '0')}.${
    z.year ? z.year.toString() : todayAsCalendarDay().getUTCFullYear().toString()
  }`;
}

export function generateSonderzahlungen(satzNummer: string, persons: LodasPersonData[]) {
  const mappedLine: string[] = [];

  for (const person of persons) {
    if (!person.bewegungSonderzahlungen.length) continue;
    for (let i = 0; i < person.bewegungSonderzahlungen.length; i++) {
      const sonderzahlung = person.bewegungSonderzahlungen.at(i);

      if (!sonderzahlung) throw new Error('No sonderzahlung at index ' + i);

      if (!allowedTypes.includes(sonderzahlung.art as Lohnart)) continue;
      mappedLine.push(
        `${satzNummer};${getDate(sonderzahlung)};"${person.lodasPersonalNr}";${
          sonderzahlung.betrag.toFixed(2).replaceAll('.', ',') ?? ''
        };${sonderzahlung.art === Lohnart.MEHR_ARBEIT ? '1' : '2'};${sonderzahlung.kostenstelle};${
          customLodasMapForSpecificThings[sonderzahlung.art]
        };`,
      );
    }
  }

  return mappedLine.join('\r\n');
}
